export default {
  set (state, conversations) {
    state.conversations = conversations
  }
}
